import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Calendar: React.FC<IconComponentProps> = ({
  className,
  strokeWidth = '1.5',
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.46484 7.41064H11.5363"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.46484 10.9468H8.00064"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.10727 2.69678C1.79469 2.69678 1.49493 2.82096 1.2739 3.04198C1.05289 3.26301 0.928711 3.56277 0.928711 3.87535V13.8932C0.928711 14.2058 1.05289 14.5056 1.2739 14.7266C1.49493 14.9476 1.79469 15.0718 2.10727 15.0718H13.893C14.2056 15.0718 14.5054 14.9476 14.7264 14.7266C14.9473 14.5056 15.0716 14.2058 15.0716 13.8932V3.87535C15.0716 3.56277 14.9473 3.26301 14.7264 3.04198C14.5054 2.82096 14.2056 2.69678 13.893 2.69678H2.10727Z"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.875 0.928711V4.46443"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.125 0.928711V4.46443"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
